import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-ten',
  templateUrl: './step-ten.component.html',
  styleUrls: ['./step-ten.component.scss']
})
export class StepTenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
